import { render } from "./regin.vue?vue&type=template&id=a21ed348&scoped=true"
import script from "./regin.vue?vue&type=script&lang=js"
export * from "./regin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21ed348"]])

export default __exports__